import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { CONSTANT } from '../../utils/constant';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';

const BcxCareForm = ({ values, labels, touched, errors }) => {
  const {
    KEYS: { ROLES }
  } = CONSTANT;
  return (
    <>
      {/* <div className="main-content-form-headers">
        <span className="select-placeholder">{labels.XID_TID}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.xid && touched.xid ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.XID_TID_PLACEHOLDER}
          className="select-style"
          type="text"
          name="xid"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.xid}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div> */}
      {/* {values.userRole !== ROLES.SALES_MANAGER && (
        <>
          <div className="main-content-form-headers">
            <span className="select-placeholder">{labels.SALE_MANAGER}</span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${errors.salesManager && touched.salesManager ? 'error' : ''
              }`}
          >
            <Field
              placeholder={labels.PLACEHOLDER_MANAGER}
              name="salesManager"
              className="select-style"
              type="text"
            />
            <>
              <div className="error_messages">
                <span className="registration-error">
                  {errors.salesManager}
                </span>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
          <div className="main-content-form-headers">
            <span className="select-placeholder">
              {labels.SALE_MANAGER_EMAIL}
            </span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${errors.salesManagerEmail && touched.salesManagerEmail
              ? 'error'
              : ''
              }`}
          >
            <Field
              placeholder={labels.PLACEHOLDER_MANAGER_EMAIL}
              name="salesManagerEmail"
              className="select-style"
              type="text"
            />
            <>
              <div className="error_messages">
                <span className="registration-error">
                  {errors.salesManagerEmail}
                </span>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
        </>
      )} */}
    </>
  );
};

BcxCareForm.propTypes = {
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired
};

export default BcxCareForm;
